export const PERSONAL_CENTER_SECTION_KEYS = {
  PROFILE: '个人信息',
  COMPANY_PROFILE: '公司信息',
  WALLET: '我的钱包',
  POINTS: '我的积分',
  ORDERS: '我的订单',
  DOCUMENTS: '我的单据',
  CLOUD_DRIVE: '我的云盘',
  SHIPPING_ADDRESS: '收货地址',
  INVOICE: '开票资料',
  ACCOUNT_AUTHORIZATION: '账号授权',
  ACCOUNT_SECURITY: '账号安全',
} as const

export type PersonalCenterSectionKey = (typeof PERSONAL_CENTER_SECTION_KEYS)[keyof typeof PERSONAL_CENTER_SECTION_KEYS]

export const PERSONAL_CENTER_SECTIONS = [
  { key: PERSONAL_CENTER_SECTION_KEYS.PROFILE, title: PERSONAL_CENTER_SECTION_KEYS.PROFILE },
  { key: PERSONAL_CENTER_SECTION_KEYS.WALLET, title: PERSONAL_CENTER_SECTION_KEYS.WALLET },
  { key: PERSONAL_CENTER_SECTION_KEYS.POINTS, title: PERSONAL_CENTER_SECTION_KEYS.POINTS },
  { key: PERSONAL_CENTER_SECTION_KEYS.ORDERS, title: PERSONAL_CENTER_SECTION_KEYS.ORDERS },
  { key: PERSONAL_CENTER_SECTION_KEYS.DOCUMENTS, title: PERSONAL_CENTER_SECTION_KEYS.DOCUMENTS },
  { key: PERSONAL_CENTER_SECTION_KEYS.CLOUD_DRIVE, title: PERSONAL_CENTER_SECTION_KEYS.CLOUD_DRIVE },
  {
    key: PERSONAL_CENTER_SECTION_KEYS.SHIPPING_ADDRESS,
    title: PERSONAL_CENTER_SECTION_KEYS.SHIPPING_ADDRESS,
  },
  { key: PERSONAL_CENTER_SECTION_KEYS.INVOICE, title: PERSONAL_CENTER_SECTION_KEYS.INVOICE },
  {
    key: PERSONAL_CENTER_SECTION_KEYS.ACCOUNT_SECURITY,
    title: PERSONAL_CENTER_SECTION_KEYS.ACCOUNT_SECURITY,
  },
] as const
